import React from 'react';
import StaffManagementTab from '../StaffManagementTab';

const StaffListTab = ({ hotelId, token, user }) => {
  // Reuse the existing StaffManagementTab component for basic staff directory
  return <StaffManagementTab />;
};

export default StaffListTab;
